import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.188 1.5H10.081C10.297 1.5 10.504 1.586 10.656 1.738L13.387 4.469C13.539 4.621 13.625 4.828 13.625 5.044V13.688C13.625 14.136 13.261 14.5 12.813 14.5H3.188C2.739 14.5 2.375 14.136 2.375 13.688V2.313C2.375 1.864 2.739 1.5 3.188 1.5Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.24,
			y: 6.021,
			width: 4.86,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.447,
			y: 5.865,
			width: 1.313,
			height: 1.313,
			rx: .656,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.24,
			y: 8.646,
			width: 4.86,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.447,
			y: 8.49,
			width: 1.313,
			height: 1.313,
			rx: .656,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.24,
			y: 11.271,
			width: 4.86,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.447,
			y: 11.115,
			width: 1.313,
			height: 1.313,
			rx: .656,
			fill: "currentColor"
		})
	]
});
export default SvgChecking;
